/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'fabric.linkPicker.button.cancel': '取消',
  'fabric.linkPicker.button.insert': '插入',
  'fabric.linkPicker.button.save': '保存',
  'fabric.linkPicker.clearLink': '清除',
  'fabric.linkPicker.clearLinkText': '清除文本',
  'fabric.linkPicker.hyperlink.searchLinkResults':
    '{count, plural, =0 {未找到结果} other {找到 {count,number} 个结果}}',
  'fabric.linkPicker.linkAriaLabel': '在字段中输入或粘贴链接',
  'fabric.linkPicker.linkHelperTextAriaLabel': '链接显示助手文本',
  'fabric.linkPicker.linkHelperTextLabel': '为此链接提供标题或描述',
  'fabric.linkPicker.linkInvalid': '请输入有效的 URL。',
  'fabric.linkPicker.linkLabel': '链接',
  'fabric.linkPicker.linkPlaceholder': '粘贴链接',
  'fabric.linkPicker.linkTextAriaLabel': '链接显示文本',
  'fabric.linkPicker.linkTextLabel': '显示文本（可选）',
  'fabric.linkPicker.linkTextPlaceholder': '待显示的文本',
  'fabric.linkPicker.listTitle.recentlyViewed': '最近查看',
  'fabric.linkPicker.listTitle.results': '结果',
  'fabric.linkPicker.search.error.description': '如果此问题依然存在，请刷新页面或联系 <a>Atlassian 支持团队</a>。',
  'fabric.linkPicker.search.error.heading': '加载数据时出现问题。',
  'fabric.linkPicker.search.error.retry': '刷新',
  'fabric.linkPicker.search.linkAriaLabel': '在字段中输入内容时，下方会显示建议内容',
  'fabric.linkPicker.search.linkLabel': '搜索或粘贴链接',
  'fabric.linkPicker.search.linkPlaceholder': '查找最近的链接或粘贴新链接',
  'fabric.linkPicker.search.noResults.description': '请使用其他词语重试。',
  'fabric.linkPicker.search.noResults.heading': '未找到符合搜索条件的内容。',
  'fabric.linkPicker.status.submitting': '正在提交',
  'fabric.linkPicker.time.message.updated': '更新时间：{time}',
  'fabric.linkPicker.time.message.viewed': '查看时间：{time}',
  'fabric.linkPicker.unhandledError.description': '请尝试重新加载该页面。',
  'fabric.linkPicker.unhandledError.heading': '出错了！',
};
